<script>
    import Layout from '../../layouts/main'
    import PageHeader from '@/components/page-header'

    import { authWellyMethods } from "@/state/helpers";
    import { apiCore }  from '../../../constants'
    import axios from 'axios'
    import Swal from "sweetalert2"

    export default {
        components: { Layout, PageHeader },
        props: {},
        data() {
            return {
                sucursales: null
            };
        },
        computed: {
        },
        created: () => {
        },
        methods: {
            ...authWellyMethods,
            getSucursales(){
                this.sucursales = null
                let url = `${apiCore}/api/welly/admin/sucursal/to/approve`
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                //console.log(tok)
                axios
                .get(url, {
                        headers: {'Authorization': tok},
                })
                .then(r => r.data)
                .then(res => {
                    // eslint-disable-next-line
                    //console.log(res)
                    if (res.valid) {
                        // eslint-disable-next-line
                        console.log(res)
                        this.sucursales = res.restos
                    } 
                })
            },
            approveSucursal(idSucursal){
                let url = `${apiCore}/api/welly/admin/sucursal/${idSucursal}/approve`
                
                // eslint-disable-next-line
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                //console.log(tok)
                axios
                .put(url, {}, {
                        headers: {'Authorization': tok},
                })
                .then(r => r.data)
                .then(res => {
                    // eslint-disable-next-line
                    //console.log(res)
                    if (res.valid) {
                        // eslint-disable-next-line
                        //console.log(res)
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: "Sucursal aprobada con éxito.",
                            showConfirmButton: false,
                            timer: 4500
                        });

                        this.getSucursales()
                    }
                    else{
                        Swal.fire({
                            position: "top-end",
                            icon: "error",
                            title: res.msg,
                            showConfirmButton: false,
                            timer: 4500
                        });
                    } 
                })
            }
        },
        mounted() {
            this.chkToken()
            const user = JSON.parse(localStorage.getItem('user'));
            this.user = user
            this.getSucursales()
        }
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card-welly">
                    <div class="row">
                        <div class="col-md-12 container-welly" v-if="sucursales == null">
                            <h3 class="title-card">
                                <br/>
                                NO HAY SUCURSALES POR AUTORIZAR
                                <br/><br/>
                            </h3>
                        </div>   
                        <div class="col-md-12 container-welly" v-if="sucursales != null">
                            <div class="row scroll1">

                                <div class=" col-sm-12 col-md-12" style="margin: 10px 0 10px 0;">
                                    <h3 class="title-card">
                                        SUCURSALES PENDIENTES DE AUTORIZAR
                                    </h3>
                                    <div class="table-responsive">
                                        <table class="table mb-0">
                                            <thead class="table-head">
                                                <tr>
                                                    <th style="width:5%;">No.</th>
                                                    <th style="width:30%;">Nombre</th>
                                                    <th style="width:35%;">Dirección</th>
                                                    <th>Tipo</th>
                                                    <th class="center">Detalle</th>
                                                </tr>
                                            </thead>
                                            <tbody class="table-body">
                                                <tr v-for="(sucursal,index) in sucursales" :key="index">
                                                    <th>{{index + 1}}</th>
                                                    <th>
                                                        <b>{{sucursal.aliasSucursal}}</b>
                                                        <br/>
                                                        {{sucursal.name}}
                                                    </th>
                                                    <th>
                                                        {{sucursal.address}}
                                                        <br/>
                                                        <span style="font-size:0.7em;">{{sucursal.lat}}, {{sucursal.lng}}</span>
                                                    </th>
                                                    <th>
                                                        <img src="@/assets/images/special/ACC2_BLACK.svg" v-show="sucursal.glutenFree" style="margin: 0 5px 0 0;" height="20"/>
                                                        <img src="@/assets/images/special/VEGGIE_BLACK.svg" v-show="sucursal.veggie" style="margin: 0 5px 0 0;" height="20"/>
                                                        <img src="@/assets/images/special/CHEESE_BLACK.svg" v-show="sucursal.vegan" style="margin: 0 5px 0 0;" height="20"/>
                                                        <span v-show="!sucursal.glutenFree && !sucursal.veggie && !sucursal.vegan">Sin definir</span>
                                                    </th>
                                                    <th class="center">
                                                        <b-button class="button-icon" title="Autorizar sucursal" @click="approveSucursal(sucursal._id)" >
                                                            <i class="bx bx-check-shield font-size-18"></i>
                                                        </b-button>
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>

                            <br/>
                        </div>
                    </div>
                </div>  
            </div>
        </div>

        <br/><br/><br/>

    </Layout>
</template>

<style scoped>
</style>